import {CsvModel} from "../../util/CSVWriteUtil";
import {KeyData, KeyHistoryRecord} from "../../api/Model";
import {EmployeeMap} from "../../api/EmployeeMapStore";

type Row = {
    key: KeyData,
    historyRecord: KeyHistoryRecord,
    hibobId?: string,
};

const keyCsvModel = new CsvModel<Row>([
    {
        header: 'Key Number',
        value: row => row.key.keyNumber,
    },
    {
        header: 'NFC',
        value: row => row.key.transponderId ?? '',
    },
    {
        header: 'Tags',
        value: row => row.key.tags.map(tag => tag.name).join(' '),
    },
    {
        header: 'Location',
        value: row => row.historyRecord.location.type,
    },
    {
        header: 'Holder',
        value: row => row.historyRecord.location.type === 'with-employee'
            ? row.historyRecord.location.employee.fullName
            : row.historyRecord.location.type === 'with-guest'
                ? row.historyRecord.location.fullName
                : '',
    },
    {
        header: 'Employee HiBob ID',
        value: row => row.hibobId ?? '',
    },
    {
        header: 'Vault',
        value: row => row.historyRecord.vault.name,
    },
    {
        header: 'From',
        value: row => row.historyRecord.from || '',
    },
    {
        header: 'To',
        value: row => row.historyRecord.to || '',
    },
    {
        header: 'Notes',
        value: row => row.historyRecord.notes || '',
    },
]);

export function downloadKeyCsv(keys: KeyData[], employeeMap: EmployeeMap, includeHistory: boolean) {
    const date = new Date();
    keyCsvModel.downloadCsv(
        `keys_export_${date.toISOString()}.csv`,
        keys.flatMap(key =>
            (includeHistory ? key.history : key.history.filter(record => !record.to))
                .map<Row>(historyRecord => ({
                    key,
                    historyRecord,
                    hibobId: historyRecord.location.type === 'with-employee'
                        ? employeeMap.get(historyRecord.location.employee)?.hibobId
                        : '',
                }))
        ),
    )
}
